//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, withStyles } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
}));
const styles = theme => ({
    previewBodyBg: {
        background: '#F1F8F8',
        border: '1px dashed #1D8A8B',
        borderRadius: '8px',
        textAlign: 'center',
        width: '270px',
        height: '180px',
        margin: 'auto',
        marginTop: '8px',
    },
    previewImageBg: {
        border: '1px solid #1D8A8B',
        borderRadius: '8px',

    },

    plusIconOutlined: {
        marginTop: '79px',
        color: '#1D8A8B',
        fontSize: '28px',
    },

    previewBodyBanner: {
        borderRadius: '8px',
        width: '270px',
        height: '180px',
        marginTop: '8px',
    },
    subBanner: {
        width: '273px',
        height: '42px',
        marginTop: '8px',
        borderRadius: '4px',
        fontSize: '12px',
        background: '#FFF8E5',
        paddingTop: '8px',
        textAlign: 'center',
    },
});

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { props } = params;
    const { classes } = props;
    const defns = {};

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ImagePreviewer = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { bannerUrl } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            {bannerUrl === '' ? (
                <div {...defns.previewBodyBg}>
                    <CloudUploadIcon {...defns.plusIconOutlined} />
                </div>
            ) : (
                <div {...defns.previewImageBg}>
                    <img src={bannerUrl} alt="" {...defns.previewBodyBanner} />
                </div>
            )}
            <div {...defns.subBanner}>We recommend using an image with 3:2 aspect ratio. E.g. 450px width and 300px height.</div>
        </div>
    );
};

export default withStyles(styles)(ImagePreviewer);
